import {
  CaretDownFilled,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, Button, Dropdown, Space } from "antd";
import { useCallback } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import { removeTenant } from "../../common/utils/common";
import { _STYLES } from "../../common/utils/customStyles";
import headerMenuStyles from "../headerMenu/headerMenuStyles";

const items = [
  {
    label: "Logout",
    key: "logout",
    icon: <LogoutOutlined />,
  },
];

const { textSm3, w100, textSm2 } = _STYLES;
const { userMenuWrap, userBtn } = headerMenuStyles;
const useStyles = createUseStyles({
  textSm3,
  w100,
  userMenuWrap,
  userBtn,
  textSm2,
});

const UserMenu = () => {
  const classes = useStyles();

  const { loggedInUser } = useSelector((state) => state.common);

  const { loginWithRedirect, logout } = useAuth0();

  const handleMenuClick = useCallback(
    (e) => {
      switch (e.key) {
        case "login": {
          loginWithRedirect();
          break;
        }
        case "logout": {
          removeTenant();

          logout({
            logoutParams: {
              returnTo: window.location.origin,
            },
          });
          break;
        }
        default: {
          throw new Error("Unspecified option");
        }
      }
    },
    [loginWithRedirect, logout]
  );

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  if (!loggedInUser) {
    return null;
  }

  const { avatarUrl, firstName, lastName, roleName } = loggedInUser;

  return (
    <Dropdown menu={menuProps}>
      <Button
        className={classes.userBtn}
        icon={<CaretDownFilled />}
        iconPosition="end"
        block
        type="text"
      >
        <Space align="center" className={classes.w100} size={16}>
          <Avatar src={avatarUrl} size={40} icon={<UserOutlined />} />
          <Space size={0} direction="vertical">
            <h6 className={classes.textSm3}>{firstName + " " + lastName}</h6>
            <span className={classes.textSm2 + " " + classes.colorText}>
              {roleName}
            </span>
          </Space>
        </Space>
      </Button>
    </Dropdown>
  );
};

export default UserMenu;
